import { SharedModule } from '../../../layout/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '../../../pipes/pipes.module';
import { EcoLayoutContainerComponent } from './eco-layout-container.component';
import { EcoSidebarComponent } from './eco-sidebar/eco-sidebar.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    EcoLayoutContainerComponent,
    EcoSidebarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    RouterModule,
  ],
  exports: [
    EcoLayoutContainerComponent, 
    EcoSidebarComponent, 
  ]
})
export class EcoLayoutModule { }
